exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mobile-profile{width:100%;height:64px;padding:12px 16px;border-bottom:1px solid #eee;margin:0}.mobile-profile h3{margin:0;padding:8px 0}.mobile-profile .asda-btn{width:116px;margin:0 8px 0 0}.mobile-profile .asda-btn.mobile-right{margin:0 0 0 8px}.mobile-profile .asda-btn.full{width:100%}@media (min-width:768px){.mobile-profile{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./components/MobileProfile/index.scss
// module id = 905
// module chunks = 0